import { createSlice } from '@reduxjs/toolkit'

export interface AppState {
  errorMessage: string
}

const initialState: AppState = {
  errorMessage: '',
}

export const AppSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    resetState: (state) => ({
      ...initialState,
    }),
    setErrorMessage: (state, { payload }: { payload: string }) => ({
      ...state,
      errorMessage: payload,
    }),
    logout: (state) => {
      // clear redux state - this is done in store.ts
    },
  },
  extraReducers: (builder) => {},
})

export const { resetState, setErrorMessage, logout } = AppSlice.actions

export default AppSlice.reducer
